/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Try_LoadingInputs */

const en_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const zh_hans1_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中…`)
};

const pt_br2_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const es_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fr_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement...`)
};

const de_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const ru_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const it_endpoint_try_loading = /** @type {(inputs: Endpoint_Try_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Endpoint_Try_LoadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_try_loading = /** @type {((inputs?: Endpoint_Try_LoadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Try_LoadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_try_loading(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_try_loading(inputs)
	if (locale === "es") return es_endpoint_try_loading(inputs)
	if (locale === "fr") return fr_endpoint_try_loading(inputs)
	if (locale === "de") return de_endpoint_try_loading(inputs)
	if (locale === "ru") return ru_endpoint_try_loading(inputs)
	if (locale === "it") return it_endpoint_try_loading(inputs)
	return en_endpoint_try_loading(inputs)
});